import { useMutation } from "react-query";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deletePhoneCenter = ({ PhoneCenterId }: { PhoneCenterId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/PhoneCenters/DeletePhoneCenter/${PhoneCenterId}`);
};

type QueryFnType = typeof deletePhoneCenter;

type UseDeletePhoneCenterOptions = {
  PhoneCenterId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeletePhoneCenter = ({ config }: UseDeletePhoneCenterOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στην διαγραφή του Τηλεφωνικού Κέντρου.`, 500);
      console.error("Couldnt delete PhoneCenter", error);
      setIsNotificationVisible(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllPhoneCenters"]);
      addNotification(`Το Τηλεφωνικό Κέντρο Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deletePhoneCenter,
  });
};
